import { PaymentStore } from "@models/android-payments.model"

import { BaseHttpProvider } from "./base-http.provider"

export class AndroidPaymentsProvider extends BaseHttpProvider {
  async find() {
    const response = await this.execute({
      uri: "/cypix-payments",
      method: "GET",
    })

    return response
  }

  async getBundles(bundleNames: string[], apiKey: string, store: PaymentStore) {
    const response = await this.execute({
      uri: `/purchases/bundles/?name=${bundleNames.join(
        ",",
      )}&apiKey=${apiKey}&store=${store}`,
      method: "GET",
      api: "pure",
      userAgent: "Pure",
    })

    return response
  }

  async getPaymentUrl(
    bundleName: string,
    userId: string,
    backUrl?: string,
    apiKey?: string,
    userAgent?: "Pure",
    store?: string,
    backUrlFail?: string,
  ) {
    const response = await this.execute({
      uri: `/purchases/order/${store}/request/`,
      method: "POST",
      api: "pure",
      userAgent,
      data: {
        user_id: userId,
        apiKey,
        bundle: bundleName,
        return_url: backUrl,
        return_url_fail: backUrlFail || backUrl,
      },
    })

    return response
  }
}
